import { render, staticRenderFns } from "./Summary.html?vue&type=template&id=3941c2a8&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./Summary.scss?vue&type=style&index=0&id=3941c2a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3941c2a8",
  null
  
)

export default component.exports